import store from '@store';

export default {
  methods: {
    setBreadcrumb: (breadcrumb = []) => store.dispatch('breadcrumb/set', breadcrumb),
  },
};
